<template>
    <div style="padding: 0 3px;">
        <v-layout wrap>
            <v-flex xs12>
                <img :src="src" :alt="alt" style="max-width: 100%;">
            </v-flex>
            <v-flex xs12>
                <v-btn color="error" block small @click="remove"><i class="material-icons"> delete </i></v-btn>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
    props: {
        src: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            default: ''
        },
        id: {
            type: [Number, String],
            default: () => parseInt(Math.random() * 10000000000)
        },
        thumbnail: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        remove() {
            this.$emit('remove', this.id);
        }
    }
}
</script>
